import { authClient, API } from "../../utils/index";

/** Todas las entradas, incl. borradores (solo admin, listado del backoffice). */
export const getBlogPostsAdmin = () => {
	return authClient().get(`${API}/blog-post?all=1`);
};

export const getBlogPostById = (id) => {
	return authClient().get(`${API}/blog-post/${id}`);
};

export const postBlogPost = (body) => {
	return authClient().post(`${API}/blog-post`, body);
};

export const putBlogPost = (id, body) => {
	return authClient().put(`${API}/blog-post/${id}`, body);
};

/** Publicar ahora (atajo desde el listado) o cambiar estado. */
export const publishBlogPost = (id, publishedOrStatus) => {
	const body =
		typeof publishedOrStatus === "string"
			? { status: publishedOrStatus }
			: { status: publishedOrStatus ? "published" : "draft", published: !!publishedOrStatus };
	return authClient().post(`${API}/blog-post/${id}/publish`, body);
};

export const deleteBlogPost = (id) => {
	return authClient().delete(`${API}/blog-post/${id}`);
};
